// 文件：src/components/ScrollToTop.js
// 作用：每次路由变更时，自动把视口滚回顶部；若是带 #hash 的锚点跳转，则保留锚点行为。

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    // 对锚点跳转（/page#section）不强制回顶，保持浏览器默认滚到锚点
    if (hash) return;

    if ('scrollRestoration' in window.history) {
      try { window.history.scrollRestoration = 'manual'; } catch (e) {}
    }

    // 用 rAF 确保在布局完成后再滚动，避免个别页面首屏高度抖动
    window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    });
  }, [pathname, search, hash]);

  return null;
}
